import React, { useState } from 'react';
import LandingPage from './components/LandingPage';
import DashboardLayout from './components/DashboardLayout';
import { DashboardHome, TransactionsView, AIAssistantView } from './components/Views';
import { ViewState, Language } from './types';

const App: React.FC = () => {
  // Simulate authentication state
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentView, setCurrentView] = useState<ViewState>(ViewState.DASHBOARD);
  // Default language set to Spanish
  const [language, setLanguage] = useState<Language>('ES');

  const handleLogin = () => {
    // In a real app, perform auth check here
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setCurrentView(ViewState.DASHBOARD);
  };

  if (!isLoggedIn) {
    return (
        <LandingPage 
            onLogin={handleLogin} 
            language={language} 
            setLanguage={setLanguage} 
        />
    );
  }

  return (
    <DashboardLayout 
        currentView={currentView} 
        setView={setCurrentView} 
        onLogout={handleLogout}
        language={language}
    >
        {currentView === ViewState.DASHBOARD && <DashboardHome language={language} />}
        {currentView === ViewState.TRANSACTIONS && <TransactionsView language={language} />}
        {currentView === ViewState.AI_ASSISTANT && <AIAssistantView />}
        {/* Placeholder for Cards view */}
        {currentView === ViewState.CARDS && (
             <div className="flex flex-col items-center justify-center h-96 text-center">
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                    <span className="text-4xl">💳</span>
                </div>
                <h2 className="text-2xl font-bold text-slate-900 mb-2">Cards Management</h2>
                <p className="text-slate-500 max-w-md">
                    Manage your physical and virtual debit cards here. Freeze cards, set limits, or order new ones instantly.
                </p>
             </div>
        )}
    </DashboardLayout>
  );
};

export default App;